export const adjusters = [
  {
    id: 1,
    name: '염선무',
    region: '전국',
    image: '/adjuster/adjuster1.png',
    label: '대표 손해사정사',
    detail: '#손해사정사 선임권 #실손보험 #배상책임',
  },
  {
    id: 2,
    name: '황인규',
    region: '서울, 경기, 인천',
    image: '/adjuster/adjuster4.png',
    label: '이사 | 파트너 손해사정사',
    detail: '#손해사정사 선임권 #화재 #재물보험 #누수 #배상책임 #후유장해 #상해 #질병',
  },
  {
    id: 3,
    name: '장유라',
    region: '전국',
    image: '/adjuster/adjuster5.png',
    label: '파트너 손해사정사',
    detail: '#손해사정사 선임권 #실손보험',
  },
  {
    id: 4,
    name: '남궁재선',
    region: '서울, 수도권',
    image: '/adjuster/adjuster11.png',
    label: '파트너 손해사정사',
    detail: '#손해사정사 선임권 #실손보험',
  },
  {
    id: 5,
    name: '안준용',
    region: '전국',
    image: '/adjuster/adjuster3.png',
    label: '파트너 손해사정사',
    detail:
      '#손해사정사 선임권 #실손보험 #여성형 여유증 실손보험금 전액지급 #일반암 #진단금 #교통사고',
  },
  {
    id: 6,
    name: '조강희',
    region: '대전, 충청지역',
    image: '/adjuster/adjuster2.png',
    label: '파트너 손해사정사',
    detail:
      '#손해사정사 선임권 #실손보험 #배상책임 #백내장 입원 보험금 전액 지급 #고지의무 확인 사고 다수 처리 #진단금',
  },
  {
    id: 7,
    name: '양순규',
    region: '전국',
    image: '/adjuster/adjuster7.png',
    label: '파트너 손해사정사',
    detail: '#손해사정사 선임권 #실손보험 #교통사고 #후유장해 #진단금',
  },
  {
    id: 8,
    name: '김은선',
    region: '경기 남부',
    image: '/adjuster/adjuster8.png',
    label: '파트너 손해사정사',
    detail:
      '#손해사정사 선임권 #질병보험 #배상책임 #암 진단비 #뇌,심혈관질환 관련 진단금 #교통사고',
  },
  {
    id: 9,
    name: '이명진',
    region: '대구, 부산, 경북, 경남',
    image: '/adjuster/adjuster6.png',
    label: '파트너 손해사정사',
    detail: '#손해사정사 선임권 #실손보험',
  },
  {
    id: 10,
    name: '이성열',
    region: '서울, 경기북부',
    image: '/adjuster/adjuster10.png',
    label: '파트너 손해사정사',
    detail: '#손해사정사 선임권 #실손보험 #배상책임 #후유장해 #상해질병 #진단비 #교통사고',
  },
  {
    id: 11,
    name: '이성식',
    region: '전국',
    image: '/adjuster/adjuster9.png',
    label: '파트너 손해사정사',
    detail: '#손해사정사 선임권 #실손보험 #상해보험 #질병보험 #배상책임',
  },
  {
    id: 12,
    name: '최유진',
    region: '전국',
    image: '/adjuster/adjuster12.png',
    label: '파트너 손해사정사',
    detail: '#손해사정사 선임권 #실손보험',
  },
  // ... 생략
];
